import React, { Component } from 'react';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade } from 'react-bootstrap';
import YouTube from 'react-youtube';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { AutoAffix } from 'react-overlays';

import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';

export default class NodeBlurb extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h3>Node</h3>
                <p className='blurb-text'>
                  Node is a project that I worked on as part of a team of 11 for the Global Game Jam 2017. The game was developed, from pen and paper prototype to downloadable game (and trailer!) in less than 48 hours.
                </p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/NodeBlurb.jsx